// extracted by mini-css-extract-plugin
export default {"subtitle":"styles_subtitle__sFvxa","subtitleIcon":"styles_subtitleIcon__452Q6"};